import { RequestPolicy } from 'urql';

import { useBagCountQuery } from './GraphQL/BagCount.generated';

/**
 * Returns the current bag count from the cache.
 */
export const useBagCount = (params: BagCountParams = {}) => {
  const { requestPolicy = 'cache-only', pause = false } = params;

  const [response] = useBagCountQuery({ requestPolicy, pause });

  const isLoadingBagCount = response.fetching;
  const bagCount = response.data?.cart?.lineItems?.length ?? 0;

  return { bagCount, isLoadingBagCount };
};

// ─── Types ───────────────────────────────────────────────────────────────────

type BagCountParams = {
  requestPolicy?: RequestPolicy;
  pause?: boolean;
};
